import * as lbFunctions from '../functions.js';

(function ($) {
	$(document).ready(function () {

		// Função para verificar se o elemento está na viewport
		$.fn.isInViewport = function () {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();

			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();

			return elementBottom > viewportTop && elementTop < viewportBottom;
		};

		/*---------------------------------------------------
			alert antes de sair a página
		---------------------------------------------------*/
		const urlParams = new URLSearchParams(window.location.search);
		const creating = urlParams.get('creating');
		if ('escola' === creating) {
			$(window).on('beforeunload', function () {
				return 'Lembre-se de salvar antes de sair';
			});
		}

		/*---------------------------------------------------
			foco automático — opt-in (data-lb-autofocus)
		---------------------------------------------------*/
		// Antes focava o 1º campo visível de QUALQUER página: no celular abria
		// o teclado por cima da tela. Agora só foca dentro de um contêiner
		// marcado com data-lb-autofocus (matrícula, criar/editar recurso…) e,
		// em tela de toque, só com data-lb-autofocus="sempre". O atributo
		// autofocus no próprio campo continua com o navegador (e o htmx).
		lbAutofocus(document);
		document.addEventListener('htmx:afterSettle', function (e) {
			// Alpine termina de montar (x-show) logo depois da troca.
			setTimeout(function () {
				lbAutofocus(e.detail && e.detail.elt ? e.detail.elt : document);
			}, 50);
		});

		function lbAutofocus(root) {
			var $alvos = $(root).find('[data-lb-autofocus]').addBack('[data-lb-autofocus]');
			if (!$alvos.length) return;

			// Já tem campo com foco (a pessoa começou a digitar): não rouba.
			var ativo = document.activeElement;
			if (ativo && $(ativo).is('input, textarea, select, [contenteditable="true"]')) return;

			var toque = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
			$alvos.each(function () {
				if (toque && 'sempre' !== this.getAttribute('data-lb-autofocus')) return;

				var $campo = $(this).find('input:visible:enabled')
					.not('.lb-change-submit, .adminbar-input, [readonly], [type="hidden"], [type="checkbox"], [type="radio"], [type="file"], [type="submit"], [type="button"]')
					.filter(function () {
						return $(this).isInViewport();
					}).first();
				if (!$campo.length) return;

				$campo.trigger('focus');
				// Move o cursor para o final do input
				var valor = $campo.val();
				$campo.val('').val(valor);
				return false;
			});
		}

		/*---------------------------------------------------
			custom styles in iframe
		---------------------------------------------------*/
		if (window !== window.top) {
			document.body.classList.add('lb-page-in-iframe');
		}

		/*---------------------------------------------------
			lb-return - volta uma pagina
		---------------------------------------------------*/
		$(document).on('click', '.lb-return', function () {
			window.history.back();
		});

		/*---------------------------------------------------
			lb-reload - atualiza a pagina
		---------------------------------------------------*/
		$(document).on('click', '.lb-reload', function () {
			location.reload();
		});

		/*---------------------------------------------------
			lb-redirect: url,int
		---------------------------------------------------*/
		lbRedirect();
		$(document).on('lbAjaxComplete', function () {
			lbRedirect();
		});
		function lbRedirect() {
			$('.lb-redirect,[lb-redirect]').each(function () { // get data.
				var data = $(this).attr('lb-redirect');
				var time = $(this).attr('lb-time');
				data = data ? data : $(this).attr('href');
				data = data.split(',');
				var counter = data[1] ? parseInt(data[1], 10) : (time ? parseInt(time, 10) : 10);
				var el = $(this);
				// if url.
				if (data[0]) {
					var interval = setInterval(function () {
						counter--;
						el.text('Você será redirecionado em ' + counter + (counter === 1 ? ' segundo' : ' segundos'));
						if (counter == 0) {
							el.text('Redirecionando...');
							clearInterval(interval);
							window.location.href = data[0];
						}
					}, 1000);
				}
			});
		}

		/*---------------------------------------------------
			lb-autopop
		---------------------------------------------------*/
		lbautopop();
		$(document).on('lbAjaxComplete', function () {
			lbautopop();
		});
		function lbautopop() {

			// Get alll modals.
			$('[lb-autopop]').each(function () {

				// Dont show again.
				if (!$(this).hasClass('lb-autopop-has-show')) {

					// Get time.
					let time = $(this).attr('lb-autopop');
					time = time ? parseInt(time) : 1;

					// Show modal.
					setTimeout(() => {

						// Bootstrap.
						if (typeof bootstrap !== "undefined" && bootstrap.Modal) {
							var modal = new bootstrap.Modal($(this)[0], { keyboard: false });
							modal.show();
						} else {
							$(this).addClass('b-is-active');
						}

						// Add control class.
						$(this).addClass('lb-autopop-has-show');

					}, time);

				}

			});

		}

		/*---------------------------------------------------
			lb-clone
		---------------------------------------------------*/
		$(document).on('click', '[lb-clone]', function (e) {
			var clone = $(this).attr('lb-clone');
			var replaceInput = $(this).attr('lb-clone-input');
			var replaceData = $(this).attr('lb-replace');
			var noAppend = $(this).attr('lb-no-append');

			var limit = parseInt($(this).attr('lb-clone-limit'));
			if (limit <= 0) {
				return;
			}
			$(this).attr('lb-clone-limit', (limit - 1));

			lbFunctions.lbConfirm(e, function () {

				if (clone) {
					//clone data.
					clone = clone.split(',');
					var elToClone = clone[0];
					var toAppend = clone[1] ? $(clone[1]) : $(this);
					var htmlToClone = $(elToClone).val();

					//replaceInput data.
					if (replaceInput) {
						replaceInput = replaceInput.split(',');

						var keyToreplaceInput = replaceInput[1] ?? '#1';
						var inputKeys = $(replaceInput[0]);

						let newKey = 0;
						if (inputKeys.length > 0 && inputKeys.val() !== '') {
							let keys = inputKeys.val().split(',').map(Number).filter(Number.isFinite);
							let bigger = Math.max.apply(null, keys);
							newKey = bigger + 1;

							//add to input.
							inputKeys.val((inputKeys.val() ? inputKeys.val() + ',' : '') + newKey);
						}

						//replaceInput.
						htmlToClone = htmlToClone.replace(new RegExp(keyToreplaceInput, 'g'), newKey);

					}

					// Replace only if needed.
					if (replaceData) {

						// Get json data.
						var replaceJson = JSON.parse(replaceData);

						// Replace string com json.
						var htmlToClone = lbFunctions.replaceStringWithJSON(htmlToClone, replaceJson);

					}

					// Remove values in {{}} brackets.
					htmlToClone = htmlToClone.replace(/{{(.*?)}}/g, '');

					// Converte a string HTML em um objeto jQuery
					var $html = $(htmlToClone);

					// temp remove select2.
					$html.find('span.select2').remove();

					// Converte o objeto jQuery de volta para uma string HTML
					htmlToClone = $html.prop('outerHTML');

					//add html.
					if (noAppend !== undefined) {
						toAppend.html(htmlToClone);
					} else {
						toAppend.append(htmlToClone);
					}

					$(document).trigger('lbLoadPlugins');

				}

			});

		});

		/*---------------------------------------------------
			lb-clone popup
		---------------------------------------------------*/
		var lbCloneCount = 1;
		$(document).on('click', '[lb-popup]', function (e) {
			var textareaId = $(this).attr('lb-popup');// textarea.

			var lbPopup = $(this).attr('lb-popup');
			lbPopup = lbPopup.split(',');

			var textareaId = lbPopup[0];
			var toAppend = lbPopup[1] || 'body';
			var toRemove = lbPopup[2] || 'true';

			// Check textarea element.
			var $textarea = $(textareaId);
			if (!$textarea) { console.error('textarea com model de popup nao existe.'); return; }

			// Data to replace
			var replaceData = $(this).attr('lb-popup-replace');

			// Replace only if needed.
			if (replaceData) {

				// Get json data.
				var replaceJson = JSON.parse(replaceData);

				// Replace string com json.
				var newPopupHtml = lbFunctions.replaceStringWithJSON($textarea.val(), replaceJson);

			} else {
				var newPopupHtml = $textarea.val();
			}

			// Remove values in {{}} brackets.
			newPopupHtml = newPopupHtml.replace(/{{(.*?)}}/g, '');

			// Converte a string HTML em um objeto jQuery
			var $newPopupHtml = $(newPopupHtml);

			// Save modal id to active after.
			lbCloneCount++;
			var newPopupHtmlId = $newPopupHtml.attr('id') + '_clone_' + lbCloneCount;

			// Change id.
			$newPopupHtml.attr('id', newPopupHtmlId);

			// Remove select2, to add after.
			$newPopupHtml.find('span.select2').remove();

			// Converte o objeto jQuery de volta para uma string HTML
			newPopupHtml = $newPopupHtml.prop('outerHTML');

			//add popup html on document.
			$(toAppend).append(newPopupHtml);

			//trigger plugins.
			$(document).trigger('lbLoadPlugins');

			//bootstrap modal.
			if (typeof bootstrap !== "undefined" && bootstrap.Modal) {
				var modalElement = document.getElementById(newPopupHtmlId);
				var modal = new bootstrap.Modal(modalElement);
				modal.show();
				// Adicione o event listener ao elemento DOM modal
				if ('true' === toRemove) {
					modalElement.addEventListener('hidden.bs.modal', function () {
						setTimeout(() => {
							modalElement.parentNode.removeChild(modalElement);
						}, 1000);
					});
				}
			}

		});

		/*---------------------------------------------------
			lb-input-sync
		---------------------------------------------------*/
		setTimeout(lbInputSync, 1000);
		$(document).on('lbAjaxComplete', function () { lbInputSync(); });
		$(document).on('lbLoadPlugins', function () { lbInputSync(); });
		function lbInputSync() {
			$('[lb-input-sync]').each(function () {
				var elToSync = $(this);
				var inputToSync = $(this).attr('lb-input-sync');
				$(document).on('change input', inputToSync, function (e) {
					var valueToSync;
					if ($(this).val()) {

						if ($(this).data('select2')) {
							valueToSync = $(this).next().find('.select2-result-card__title').text();

						} else if ($(this).is('select')) {
							valueToSync = $(this).find('option:selected').text();

						} else if ($(this).is('input[type=date]')) {
							var parts = $(this).val().split('-');
							var date = new Date(parts[0], parts[1] - 1, parts[2]);
							valueToSync = date.toLocaleDateString($('html').attr('lang'));

						} else {
							valueToSync = $(this).val();
						}
						elToSync.html(valueToSync);
					}
				});
			});
		};

		/*---------------------------------------------------
			lb-sync="target,input"
		---------------------------------------------------*/
		lbSync();
		$(document).on('lbAjaxComplete', function () { lbSync(); });
		$(document).on('lbLoadPlugins', function () { lbSync(); });
		function lbSync() {
			$('[lb-sync]').each(function () {

				var attr = $(this).attr('lb-sync');
				attr = attr.split(',');

				var target = $(attr[0]);
				var input = $(attr[1] ?? this);

				lbSyncFunc(input, target);

				$(document).on('input', input, function (e) {
					lbSyncFunc(input, target);
				});

				function lbSyncFunc(input, target) {
					var valueToSync = input.val();

					// Define value.
					if (valueToSync) {
						// If is select.
						if (input.is('select') && !target.is('select')) {
							valueToSync = input.find('option:selected').text();

							// If is date.
						} else if (input.is('input[type=date]')) {
							// Format date.
							var parts = valueToSync.split("-");
							var date = new Date(parts[0], parts[1] - 1, parts[2]);
							valueToSync = date.toLocaleDateString($('html').attr('lang'));
						}

						// Sync whith element.
						if (target.is('input') || target.is('select')) {
							target.val(valueToSync);
						} else {
							target.html(valueToSync);
						}
					}
				}

			});
		};

		/*---------------------------------------------------
			lb-remove, remove parent on click.
		---------------------------------------------------*/
		$(document).on('click', '[lb-remove]', function (e) {
			var t = this;
			lbFunctions.lbConfirm(e, function () {
				var remove = $(t).attr('lb-remove');
				if (remove) {
					$(t).parents(remove).remove();
				} else {
					$(t).remove();
				} t = undefined;
			});
		});

		/*---------------------------------------------------
			lb-change-submit, submit on change
		---------------------------------------------------*/
		$(document).on('change', '.lb-change-submit', function (e) {
			var t = this;
			lbFunctions.lbConfirm(e, function () {
				$(t).parents('form').trigger('submit');
				setTimeout(() => { $(t).prop('checked', false); }, 800);
			});
		});

		/*---------------------------------------------------
			lb-show-on-focus
		---------------------------------------------------*/
		$(document).on('focus', '[lb-show-on-focus]', function (e) {
			var lbOnFocus = $(this).attr('lb-show-on-focus');
			$(lbOnFocus).show();
		});

		$(document).on('blur', '[lb-show-on-focus]', function (e) {
			var lbOnFocus = $(this).attr('lb-show-on-focus');

			// Adiciona um pequeno atraso para permitir interações no elemento relacionado.
			setTimeout(function () {
				$(lbOnFocus).hide();
			}, 2000);
		});

		/*---------------------------------------------------
			lb-textearea-height
		---------------------------------------------------*/
		$(document).on('input', 'textarea.lb-textarea-auto-height', function (e) {
			$(this).css({ 'height': 'auto' });
			$(this).css({ 'height': $(this).scrollHeight + 'px' });
		});

		/*---------------------------------------------------
			lb-input-count, contador de caracteres em inputs e textareas
		---------------------------------------------------*/

		// Inicializa na carga inicial da página
		lbInputCountInit();
		// Re-inicializa após carregamentos AJAX
		$(document).on('lbAjaxComplete', lbInputCountInit);

		// Atualiza contador ao digitar
		$(document).on('input', '[lb-input-count]', function (e) {
			lbInputCount($(this));
		});

		// Inicializa contadores já presentes ao carregar a página:
		function lbInputCountInit() {
			$('[lb-input-count]').each(function () { lbInputCount($(this)); });
		};

		// Função principal do contador
		function lbInputCount(input) {//$(this)
			var $ta = input;

			// Obtém o máximo: primeiro do maxlength (limita), depois do lb-input-count (só visual)
			var maxlength = $ta.attr('maxlength') || $ta.attr('lb-input-count');
			var max = maxlength ? parseInt(maxlength, 10) : null;
			// Se ambos forem undefined/vazios: max = null (apenas contador sem limite)
			max = isNaN(max) ? null : max;

			// Garante wrapper e contador
			if (!$ta.parent().hasClass('lb-input-count-wrap')) {
				$ta.wrap('<div class="lb-input-count-wrap"></div>');
			}
			var $wrap = $ta.parent();
			var $counter = $wrap.find('.lb-input-count-counter');
			if ($counter.length === 0) {
				$counter = $('<span class="lb-input-count-counter" aria-live="polite"></span>');
				$wrap.append($counter);
				// o foco é removido, adiciona-se novamente
				$ta.focus();
			}

			// Atualiza contagem
			var val = $ta.val() || '';
			var count = val.length;

			// Texto do contador
			$counter.text(max != null ? (count + '/' + max) : String(count));

			// Cores por percentual (90% -> .lbt-w, 95% -> .lbt-d) - apenas se há max
			$counter.removeClass('lbt-w lbt-d');
			if (max != null && max > 0) {
				var pct = (count / max) * 100;
				if (pct >= 95) {
					$counter.addClass('lbt-d');
				} else if (pct >= 90) {
					$counter.addClass('lbt-w');
				}
			}
		}

		/*---------------------------------------------------
			lb-ramdom background color
		---------------------------------------------------*/
		$('.lb-random').each(function () {
			let bckColor = lbFunctions.getRamdomHexColor();
			let color = lbFunctions.getTextColorByBgColor(bckColor, true);
			$(this).css({ 'background-color': bckColor, 'color': color });
		});

		/*---------------------------------------------------
			lb-toggle ( esta em nova gestao )
		---------------------------------------------------*/

		// Inicializa os elementos ao carregar a página e eventos específicos
		lbToggle();
		$(document).on('lbAjaxComplete lbLoadPlugins', lbToggle);

		// Função principal para alternar elementos com base no atributo `lb-toggle`
		function lbToggle() {
			// Gerencia eventos de mudança para `checkbox` e `select`
			$(document).on('change', '[type="checkbox"][lb-toggle], select[lb-toggle]', function () {
				lbToggleElement($(this));
			});

			// Gerencia eventos de clique para outros elementos com `lb-toggle`
			$(document).on('click', '[lb-toggle]:not([type="checkbox"], select)', function () {
				lbToggleElement($(this));
			});

			// Aplica lógica ao carregar a página
			$('[type="checkbox"][lb-toggle], select[lb-toggle]').each(function () {
				lbToggleElement($(this));
			});
		}

		// Lógica para alternar visibilidade dos elementos
		function lbToggleElement($el) {
			const selectValue = $el.is('select') ? $el.val() : '';//only select value
			const toggle = $el.attr('lb-toggle');
			const [toggle1, toggle2] = toggle.split(',');
			const isReverse = $el.is('[lb-toggle-reverse]');

			if (toggle2) {
				// Alternância dupla (dois elementos separados por vírgula)
				if ($el.is(':checked')) {
					isReverse ? $(toggle1).show() : $(toggle1).hide();
					isReverse ? $(toggle2).hide() : $(toggle2).show();
				} else if ($el.is('select')) {
					isReverse ? $(toggle1).show() : $(toggle1).hide();
					isReverse ? $(toggle2 + selectValue).hide() : $(toggle2 + selectValue).show();
				} else {//unchecked
					isReverse ? $(toggle1).hide() : $(toggle1).show();
					isReverse ? $(toggle2).show() : $(toggle2).hide();
				}
			} else {
				// Alternância simples
				if ($el.is(':checked')) {
					isReverse ? $(toggle).hide() : $(toggle).show();
				} else if ($el.is('select')) {
					isReverse ? $(toggle + selectValue).hide() : $(toggle + selectValue).show();
				} else {//unchecked
					isReverse ? $(toggle).show() : $(toggle).hide();
				}
			}
		}

		/*---------------------------------------------------
			COPY data-text or html div
		---------------------------------------------------*/
		$(document).on('click', '[lb-copy]', function (e) {
			var $el = $(this);

			// Guarda o HTML original uma única vez para evitar copiar a mensagem de feedback
			var originalHtml = $el.data('lb-copy-original-html');
			if (originalHtml === undefined) {
				originalHtml = $el.html();
				$el.data('lb-copy-original-html', originalHtml);
			}

			var lbCopy = $el.attr('lb-copy');
			var lbCopyFrom = $el.attr('lb-copy-from');
			var lbCopyText = $el.attr('lb-copy-text');

			var textOnCopy = lbCopyText ? lbCopyText : '<span class="lb-s">copiado</span>';
			var textToCopy = '';

			// Define a fonte do texto a copiar
			if (lbCopyFrom) {
				var $from = $(lbCopyFrom);
				if ($from.is('input, textarea, select')) {
					textToCopy = $from.val();
				} else if ($from.hasClass('select2-hidden-accessible')) {
					textToCopy = $from.select2('data').map(function (e) { return e.text; }).join(', ');
				} else {
					textToCopy = $from.text() || $from.html();
				}
			} else if (lbCopy) {
				textToCopy = lbCopy;
			} else {
				// Usa o HTML original salvo (não o atual com a mensagem de "copiado")
				textToCopy = originalHtml;
			}

			// Remove html se houver [lb-copy-only-text].
			if ($el.is('[lb-copy-only-text]')) {
				// Cria um elemento temporário para extrair apenas o texto
				var tempDiv = $('<div>').html(textToCopy);
				textToCopy = tempDiv.text().trim();
				//remover todos os espaços extras
				textToCopy = textToCopy.replace(/\s+/g, ' ');
			}

			// Usa a API Clipboard para copiar o texto
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(textToCopy).then(function () {
					// Cancela feedback anterior caso exista
					var t = $el.data('lb-copy-timeout');
					if (t) { clearTimeout(t); }

					// Mostra feedback e agenda restauração do HTML original
					$el.html(textOnCopy);
					var timeoutId = setTimeout(function () {
						$el.html($el.data('lb-copy-original-html'));
					}, 2000);
					$el.data('lb-copy-timeout', timeoutId);
				}).catch(function (err) {
					console.error('Failed to copy: ', err);
				});
			}
		});

		/*---------------------------------------------------
			CHANGE CSSVARS
		---------------------------------------------------*/
		$(document).on('change, input, spec', '.lb-cssvar-change', function (e) {
			let cssvar = $(this).attr('lb-cssvar');
			if (cssvar) {
				let target = $(this).attr('lb-cssvar-target');
				target = target ? target : 'html';
				//change css var
				let value = $(this).val();
				$(target).css(cssvar, value);
				// also chang var color text.
				let text = lbFunctions.getTextColorByBgColor(value, false);
				$(target).css(cssvar + '-text', text);
				// rgb version.
				let rgb = lbFunctions.hexToRgb(value);
				if ($(this).data('rgb') && rgb) {
					$(target).css(cssvar + '-rgb', rgb);
					// also change text-rgb
					let textRgb = lbFunctions.hexToRgb(text);
					$(target).css(cssvar + '-text-rgb', textRgb);
					// also chance css var for logos.
					let darkLogo = lbFunctions.getTextColorByBgColor(value, false, true);
					if (darkLogo) {
						$(target).css(cssvar + '-dark', 'inline-block');
						$(target).css(cssvar + '-light', 'none');
					} else {
						$(target).css(cssvar + '-dark', 'none');
						$(target).css(cssvar + '-light', 'inline-block');
					}
				}
			}
		});

		//simple dinamic change css.
		$(document).on('change, input, spec', '[lb-css]', function (e) { lbSimpleImputCss(this); });
		$(document).on('lbAjaxComplete', function () { $('[lb-css]').each(function () { lbSimpleImputCss(this); }); });
		$(document).on('lbLoadPlugins', function () { $('[lb-css]').each(function () { lbSimpleImputCss(this); }) });
		$('[lb-css]').each(function () { lbSimpleImputCss(this); });
		function lbSimpleImputCss(el) {
			let cssvar = $(el).attr('lb-css');
			if (cssvar) {
				let target = $(el).attr('lb-css-target')
				target = target ? target : 'html';
				let value = $(el).val();
				let sufix = $(el).attr('lb-css-sufix');
				sufix = sufix ? sufix : '';
				$(target).css(cssvar, value + sufix);
			}
		}

		/*---------------------------------------------------
			DROPDOWN form escolas
		---------------------------------------------------*/
		$(document).on('click', '.lb-dropdown-form a', function (e) {
			e.preventDefault();
			var param = $(this).data('param');
			var form = $(this).parents('form');
			form.find('input[name=escola]').val(param);
			// maybe set cookie
			let cookie = $(this).parents('.lb-dropdown-form').data('cookie');
			if (cookie) {
				document.cookie = cookie + '=' + param + '; path=/';
			}
			// submit form dropdown.
			form.trigger("submit")
		});

		/*---------------------------------------------------
			DROPDOWN change
		---------------------------------------------------*/
		$(document).on('click', '.lb-dropdown-change li', function (e) {
			e.preventDefault();

			$(this).parents('.lb-dropdown-change').find('li').not(this).show();
			$(this).hide();
			$(this).parents('.lb-dropdown-change').find('.btn').html($(this).find('a').html());

			let param = $(this).data('param');

			// maybe set theme
			let theme = $(this).parents('.lb-dropdown-change').data('theme');
			if (theme) {
				$('html').attr('data-bs-theme', param);
			}
			// maybe set cookie
			let cookie = $(this).parents('.lb-dropdown-change').data('cookie');
			if (cookie) {
				document.cookie = cookie + '=' + param + '; path=/';
			}
		});

		/*---------------------------------------------------
			Change bs theme
		---------------------------------------------------*/
		$(document).on('click', '[data-selector-theme]', function (e) {
			e.preventDefault();
			// avoid closing parent dropdown when selecting inside submenu
			e.stopPropagation();

			// get theme
			const theme = $(this).data('selector-theme');
			if (theme) {
				$('html').attr('data-bs-theme', theme);
			}

			// persist cookie for 1 year
			const cookie = 'lbtheme';
			const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
			document.cookie = cookie + '=' + theme + '; path=/; expires=' + expires;

			// update UI state within the same theme selector submenu
			const $menu = $(this).closest('.theme-selector');
			if ($menu.length) {
				$menu.find('[data-selector-theme]').attr('aria-checked', 'false').removeClass('active');
				$(this).attr('aria-checked', 'true').addClass('active');
			}
		});

		// Sync initial state for theme selector based on current attribute/cookie
		$(function () {
			let currentTheme = $('html').attr('data-bs-theme');

			// If theme is empty or 'auto', default to 'color'
			if (!currentTheme || currentTheme === 'auto') {
				currentTheme = 'color';
				$('html').attr('data-bs-theme', currentTheme);

				// Set cookie with 'color' as default for 1 year
				const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
				document.cookie = 'lbtheme=color; path=/; expires=' + expires;
			}

			// Update UI state for theme selector
			$('.theme-selector').each(function () {
				const $menu = $(this);
				$menu.find('[data-selector-theme]').each(function () {
					const isCurrent = $(this).data('theme') === currentTheme;
					$(this).attr('aria-checked', isCurrent ? 'true' : 'false');
					$(this).toggleClass('active', !!isCurrent);
				});
			});
		});

		/*---------------------------------------------------
			DROPDOWN cookie (generic — legacy gestao1)
		---------------------------------------------------*/
		$(document).on('click', '.lb-dropdown-cookie a', function (e) {
			e.preventDefault();
			var cookieValue = $(this).data('param');
			let cookie = $(this).parents('.lb-dropdown-cookie').data('cookie');
			if (cookie) {
				document.cookie = cookie + '=' + cookieValue + '; path=/';
			}
			location.reload();
		});

		/*---------------------------------------------------
			PRINT
		---------------------------------------------------*/
		/*$(document).on('click', '.lb-print', function (e) {
			//$(this).addClass('lb-load');
			$(this).attr('disabled', true);
			let atual = $('html').attr('data-bs-theme');
			$('html').attr('data-bs-theme', 'light');
			setTimeout(() => {
				window.print();
				if (atual) {
					$('html').attr('data-bs-theme', atual);
				}
				//$(this).removeClass('lb-load');
				$(this).attr('disabled', false);
			}, 800);
		});*/

		/*---------------------------------------------------
			lbTextareaHtmlSync
		---------------------------------------------------*/
		lbTextareaHtmlSync();
		$(document).on('lbAjaxComplete', function () { lbTextareaHtmlSync(); });
		function lbTextareaHtmlSync() {

			// Para cada textarea com o atributo 'lb-textarea-html-sync'
			$('[lb-textarea-input-html-sync]').each(function () {
				var textarea = $(this);
				var htmlTargetId = textarea.attr('lb-textarea-input-html-sync');
				var htmlTarget = $(htmlTargetId);
				var inputsTowWatch = textarea.attr('lb-textarea-input-html-sync-inputs-watch');

				// Insuficient data.
				if (htmlTargetId.includes('#1') || !htmlTarget || !inputsTowWatch) {
					return;
				};

				var textareaInsideTarget = textarea.attr('lb-textarea-input-html-sync-target-inside');
				var textareaHtml = $(textarea.val());

				// on load.
				textareaHtml.find(textareaInsideTarget).html($(htmlTargetId).html());
				var textareaHtmlString = textareaHtml.prop('outerHTML');
				textarea.val(textareaHtmlString);

				// Watch inputs.
				$(inputsTowWatch).find('input').on('change', function (e) {
					textareaHtml.find(textareaInsideTarget).html($(htmlTargetId).html());
					var textareaHtmlString = textareaHtml.prop('outerHTML');
					textarea.val(textareaHtmlString);
				});

			});
		}

		/*---------------------------------------------
			Button link
		---------------------------------------------*/
		$(document).on('click', '.lb-btn-link', function (e) {
			var url = $(this).attr('href'); window.location.href = url;
		});

		/*---------------------------------------------
			Disable input
		---------------------------------------------*/
		$(document).on('change', '[type="checkbox"][lb-disable-input]', function (e) {
			var elId = $(this).attr('lb-disable-input');
			var el = $(elId);
			el.val('');
			if ($(this).is(":checked")) {
				el.prop('disabled', true);
			} else {
				el.prop('disabled', false);
			}
		});

		/*---------------------------------------------------
			lb-count
		---------------------------------------------------*/
		lbCount();
		$(document).on('lbAjaxComplete', function (event, args) { lbCount(args); });
		function lbCount(ajaxform = false) {
			$('[lb-count]').each(function () {
				var soma = 0;
				let inputName = $(this).attr('lb-count');
				$('input[name="' + inputName + '"]').each(function () {
					soma += parseInt($(this).val()) || 0;
				});
				var prefix = $(this).attr('lb-count-prefix') || '';
				var sufix = $(this).attr('lb-count-sufix') || '';
				$(this).text(prefix + soma + sufix);
			});
			if (ajaxform) {
				$(ajaxform.target).parents('.lb-count-box').find('[lb-count]').each(function () {
					$(this).show();
				});
			}
		}

		/*---------------------------------------------------
			select background
		---------------------------------------------------*/
		selectDinamic();
		document.addEventListener('lbAjaxComplete', selectDinamic);

		function selectDinamic() {
			// Seleciona todos os elementos <select> na página
			var selectElements = document.querySelectorAll('.lbfield select');

			// Verifica se há algum <select> encontrado antes de prosseguir
			if (selectElements.length === 0) {
				return; // Sai da função se nenhum <select> foi encontrado
			}

			// Itera sobre cada elemento <select>
			selectElements.forEach(function (selectElement) {
				// Verifica se o <select> tem pelo menos uma <option>
				if (selectElement.options.length > 0) {
					selectElement.addEventListener('change', function () {
						// Obtém a opção selecionada
						var selectedOption = selectElement.options[selectElement.selectedIndex];

						// Verifica se a opção selecionada existe
						if (selectedOption) {
							// Aplica o estilo da opção selecionada ao <select>
							selectElement.style.backgroundColor = selectedOption.style.backgroundColor || '';
							selectElement.style.color = selectedOption.style.color || '';
						}
					});

					// Aplica o estilo da opção selecionada ao carregar
					var selectedOption = selectElement.options[selectElement.selectedIndex];
					if (selectedOption) {
						selectElement.style.backgroundColor = selectedOption.style.backgroundColor || '';
						selectElement.style.color = selectedOption.style.color || '';
					}
				}
			});
		}

		/*---------------------------------------------------
			Tips condicionais (checkbox/switch/select)
			- Use data-lb-tip-map='{"valor":"texto"}' no input/select
			- Para checkbox/switch, as chaves são "true" e "false"
		---------------------------------------------------*/
		lbConditionalTips();
		$(document).on('lbAjaxComplete', function () {
			lbConditionalTips();
		});

		$(document).on('change', 'select[data-lb-tip-map], input[type="checkbox"][data-lb-tip-map]', function () {
			lbApplyConditionalTip($(this));
		});

		function lbConditionalTips() {
			$('select[data-lb-tip-map], input[type="checkbox"][data-lb-tip-map]').each(function () {
				lbApplyConditionalTip($(this));
			});
		}

		function lbParseTipMap($el) {
			var raw = $el.attr('data-lb-tip-map');
			if (!raw) return null;
			try {
				return JSON.parse(raw);
			} catch (e) {
				return null;
			}
		}

		function lbGetConditionalKey($el) {
			if ($el.is('select')) {
				var v = $el.val();
				if (Array.isArray(v)) {
					return v[0] ? String(v[0]) : '';
				}
				return v !== null && v !== undefined ? String(v) : '';
			}
			// checkbox/switch
			if ($el.is('input[type="checkbox"]')) {
				return $el.is(':checked') ? 'true' : 'false';
			}
			return '';
		}

		function lbApplyConditionalTip($el) {
			var map = lbParseTipMap($el);
			if (!map || typeof map !== 'object') return;

			var $field = $el.closest('.lbfield');
			if (!$field.length) return;

			var $tip = $field.find('.lb-field-tip').first();
			if (!$tip.length) {
				$tip = $field.find('.form-text').first();
			}
			if (!$tip.length) return;

			// Armazena o tip original como default.
			if ($tip.data('lbTipDefault') === undefined) {
				$tip.data('lbTipDefault', $tip.text());
			}

			var key = lbGetConditionalKey($el);
			var newTip = (Object.prototype.hasOwnProperty.call(map, key)) ? map[key] : (Object.prototype.hasOwnProperty.call(map, '*') ? map['*'] : null);

			if (newTip === null || newTip === undefined) {
				newTip = $tip.data('lbTipDefault');
			}

			newTip = (newTip === null || newTip === undefined) ? '' : String(newTip);

			if (newTip.trim() === '') {
				$tip.text('');
				$tip.hide();
				return;
			}

			$tip.text(newTip);
			$tip.show();
		}

		/*---------------------------------------------------
			div zoom
		---------------------------------------------------*/
		lbZoom();
		document.addEventListener('lbAjaxComplete', lbZoom);

		function lbZoom() {
			const zoomEl = document.querySelector('.lb-zoom');
			let scale = 1; // Zoom inicial
			let initialDistance = null;

			if (!zoomEl) return;

			// Função para aplicar o zoom com base na escala e na posição
			function applyZoom() {
				zoomEl.style.transform = `scale(${scale})`;
				zoomEl.style.transformOrigin = 'center center'; // Mantém o zoom centralizado
			}

			// Evento para o scroll + Ctrl (para desktops)
			zoomEl.addEventListener('wheel', (event) => {
				if (event.ctrlKey) { // Verifica se o Ctrl está pressionado
					event.preventDefault();
					scale += event.deltaY * -0.001; // Ajusta o zoom com o scroll

					// Limita o nível de zoom entre 0.5x e 3x
					scale = Math.min(Math.max(0.5, scale), 3);

					// Aplica o zoom
					applyZoom();
				}
			});

			// Evento para o gesto de pinça (para dispositivos móveis)
			zoomEl.addEventListener('touchmove', (event) => {
				if (event.touches.length === 2) { // Detecta dois toques para o gesto de pinça
					event.preventDefault();
					const [touch1, touch2] = event.touches;

					// Calcula a distância entre os dois toques
					const currentDistance = Math.sqrt(
						Math.pow(touch2.pageX - touch1.pageX, 2) +
						Math.pow(touch2.pageY - touch1.pageY, 2)
					);

					// Define a distância inicial
					if (!initialDistance) initialDistance = currentDistance;

					// Calcula a diferença de escala com base na distância inicial
					scale *= currentDistance / initialDistance;

					// Limita o nível de zoom entre 0.5x e 3x
					scale = Math.min(Math.max(0.5, scale), 3);

					// Aplica o zoom
					applyZoom();

					// Atualiza a distância inicial
					initialDistance = currentDistance;
				}
			});

			// Redefine a distância inicial quando o toque termina
			zoomEl.addEventListener('touchend', () => {
				initialDistance = null;
			});
		}

		/*---------------------------------------------------
			data-url
		---------------------------------------------------*/
		$(document).on('mousedown', '[data-url]', function (e) {
			e.preventDefault();
			var url = $(this).data('url');
			if (!url) return;

			if (e.button === 1) {
				// Botão do meio — abre em nova aba
				window.open(url, '_blank');
			} else if (e.button === 0) {
				// Esquerdo — navega na mesma aba
				window.location.href = url;
			}
		});

		/*---------------------------------------------------
			lb-sanitize-title - sanitiza texto para slug/identificador
		---------------------------------------------------*/
		$(document).on('change', '[lb-sanitize-title]', function (e) {
			let value = $(this).val();

			// Converte para minúsculas
			value = value.toLowerCase();

			// Remove acentos
			value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

			// Substitui espaços e hífens por underscore
			value = value.replace(/[\s-]+/g, '_');

			// Remove caracteres especiais (mantém apenas letras, números e underscore)
			value = value.replace(/[^a-z0-9_]/g, '');

			// Remove underscores múltiplos
			value = value.replace(/_+/g, '_');

			// Remove underscore do início e fim
			value = value.replace(/^_+|_+$/g, '');

			// Atualiza o valor do input
			$(this).val(value);
		});

		/*---------------------------------------------------
			lb-unique-value="group-name"
			Inputs com essa attr e com o mesmo group-name devem ter valores únicos.
			Verifica se o valor inserido já existe em outros inputs com o mesmo group-name.
			Se existir, limpa o valor e exibe um alerta.
			Se houver attr lb-unique-value-multiple, indica que o input é múltiplos valores separados por vírgula.
		---------------------------------------------------*/
		$(document).on('input', '[lb-unique-value]', function (e) {
			// Recupera o valor atual do input.
			let currentValue = $(this).val().trim();
			if (!currentValue) return;

			// Verifica outros inputs com o mesmo group-name.
			let isDuplicate = false;
			$('[lb-unique-value="' + $(this).attr('lb-unique-value') + '"]').not(this).each(function () {
				// Se encontrar um valor igual, marca como duplicado.
				// Se houver attr lb-unique-value-multiple, permite múltiplos valores separados por vírgula.
				if ($(this).is('[lb-unique-value-multiple]')) {
					let values = $(this).val().trim().split(',');
					if (values.includes(currentValue)) {
						isDuplicate = true;
						return false; // Sai do loop
					}
				} else {
					// Verifica valor simples.
					if ($(this).val().trim() === currentValue) {
						isDuplicate = true;
						return false; // Sai do loop
					}
				}

			});

			// Se for duplicado, limpa o valor e exibe alerta.
			if (isDuplicate) {
				$(this).focus();
				$(this).addClass('is-invalid');
				$(this).parent().find('.invalid-feedback').append('<span class="lb-unique-value-warning">Já existe.</span>');
			} else {
				$(this).removeClass('is-invalid');
				$(this).parent().find('.lb-unique-value-warning').remove();
			}
		});

	});
})(jQuery);

